import { jsxs as c, jsx as r } from "react/jsx-runtime";
import { X as y, Info as x, Sparkles as b, XCircle as C, AlertTriangle as w, CheckCircle2 as S } from "lucide-react";
import { forwardRef as I } from "react";
import { e as T } from "./palettes-DoFdaGi8.js";
function k(a) {
  const e = T[a], t = a === "warning" || a === "error";
  return {
    bg: e.bg,
    border: e.border,
    fg: e.fg,
    role: t ? "alert" : "status",
    ariaLive: t ? "assertive" : "polite"
  };
}
function j(a) {
  const e = {
    width: "var(--icon-md)",
    height: "var(--icon-md)",
    flex: "0 0 auto"
  };
  switch (a) {
    case "success":
      return /* @__PURE__ */ r(S, { "aria-hidden": !0, style: e });
    case "warning":
      return /* @__PURE__ */ r(w, { "aria-hidden": !0, style: e });
    case "error":
      return /* @__PURE__ */ r(C, { "aria-hidden": !0, style: e });
    case "accent":
    case "magenta":
    case "orange":
      return /* @__PURE__ */ r(b, { "aria-hidden": !0, style: e });
    case "info":
    case "neutral":
    default:
      return /* @__PURE__ */ r(x, { "aria-hidden": !0, style: e });
  }
}
const z = {
  display: "flex",
  alignItems: "flex-start",
  gap: "var(--space-3)",
  padding: "var(--space-3) var(--space-4)",
  borderRadius: "var(--radius-xl)",
  borderStyle: "solid",
  borderWidth: "1px",
  fontFamily: "var(--font-sans)",
  fontSize: "var(--text-sm)",
  lineHeight: "var(--line-sm)",
  color: "var(--text-primary)"
}, W = I(function({
  tone: e = "info",
  variant: t = "soft",
  icon: i,
  title: o,
  children: u,
  action: s,
  onDismiss: l,
  dismissAriaLabel: g = "Dismiss",
  style: f,
  ...v
}, p) {
  const n = k(e), d = i === void 0 ? j(e) : i, m = {
    ...z,
    background: t === "gradient" ? "var(--brand-gradient)" : n.bg,
    borderColor: t === "gradient" ? "transparent" : n.border,
    color: t === "gradient" ? "var(--text-on-accent)" : "var(--text-primary)",
    ...f
  }, h = t === "gradient" ? "var(--text-on-accent)" : n.fg;
  return /* @__PURE__ */ c(
    "div",
    {
      ref: p,
      role: n.role,
      "aria-live": n.ariaLive,
      "data-tone": e,
      "data-variant": t,
      style: m,
      ...v,
      children: [
        d ? /* @__PURE__ */ r(
          "span",
          {
            "aria-hidden": !0,
            style: {
              color: h,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              paddingTop: "2px"
            },
            children: d
          }
        ) : null,
        /* @__PURE__ */ c(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "var(--space-1)",
              flex: "1 1 auto",
              minWidth: 0
            },
            children: [
              o ? /* @__PURE__ */ r(
                "div",
                {
                  style: {
                    fontWeight: "var(--font-weight-semibold)",
                    fontSize: "var(--text-sm)",
                    lineHeight: "var(--line-sm)",
                    color: "inherit"
                  },
                  children: o
                }
              ) : null,
              /* @__PURE__ */ r(
                "div",
                {
                  style: {
                    color: t === "gradient" ? "var(--text-on-accent)" : "var(--text-secondary)",
                    fontSize: "var(--text-sm)",
                    lineHeight: "var(--line-sm)"
                  },
                  children: u
                }
              ),
              s ? /* @__PURE__ */ r("div", { style: { marginTop: "var(--space-1)" }, children: s }) : null
            ]
          }
        ),
        l ? /* @__PURE__ */ r(
          "button",
          {
            type: "button",
            "aria-label": g,
            onClick: l,
            className: "ls-focus-ring",
            style: {
              background: "transparent",
              border: "none",
              color: t === "gradient" ? "var(--text-on-accent)" : "var(--text-secondary)",
              padding: "var(--space-1)",
              borderRadius: "var(--radius-sm)",
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              flex: "0 0 auto"
            },
            children: /* @__PURE__ */ r(y, { "aria-hidden": !0, style: { width: "var(--icon-sm)", height: "var(--icon-sm)" } })
          }
        ) : null
      ]
    }
  );
});
export {
  W as B
};
//# sourceMappingURL=Banner-BBfZio8n.js.map
